import { useMemo } from 'react';
import { useAppSelector } from 'src/app/store';
import { types as rs, UiOptionGroup } from 'earn-ts';
import { useTranslation } from 'react-i18next';
import { pickName } from 'src/utils';
import OptionGroup from '../OptionGroup';

type IProps = {
  selectedFoodId: string;
  foodDef: rs.FoodItem;
  page: number;
  state: rs.OrderItem[];
  onChange: (v: rs.OrderItem[]) => void;
};

export const OptionGroupsEditor = ({
  foodDef,
  selectedFoodId,
  page,
  onChange,
  state,
}: IProps) => {
  const { language } = useTranslation(['main']).i18n;
  const { optionGroup } = useAppSelector(state => state.order);

  const opGroups: Array<[string, rs.FoodOptionGroup]> = useMemo(
    () =>
      UiOptionGroup.enabledGroups(
        foodDef.option_groups.map(it => [it, optionGroup[it]]),
        state[page],
      ),
    [selectedFoodId, page, state],
  );

  const handleChange = (optionGroup: string, option: string) => {
    //setMessageError('');
    let newLocal = [...state];
    let sel = UiOptionGroup.state2sel(
      newLocal[page].options[optionGroup] ?? { flags: [] },
    );
    let opGroupDict = Object.fromEntries(opGroups);
    UiOptionGroup.toggleOption(option, sel, opGroupDict[optionGroup]);
    newLocal[page] = {
      ...newLocal[page],
      options: {
        ...newLocal[page].options,
        [optionGroup]: { flags: UiOptionGroup.sel2state(sel) },
      },
    };
    newLocal[page].options = UiOptionGroup.filterDisabled(
      opGroupDict,
      newLocal[page].options,
      { key: optionGroup, val: newLocal[page].options[optionGroup] },
    );
    onChange(newLocal);
  };

  console.log('OptionGroupEditor render');
  
  return (
    <>
      {opGroups.map(([kgrp, grp]) => (
        <OptionGroup
          title={pickName(grp, language)}
          listGroupRadio={grp.op}
          required = {!!grp.min}
          optionGroupKey = {kgrp}
          key={kgrp}
          handleChange={handleChange}
          dataGroupSelected={state[page]?.options?.[kgrp]}
          disable={false}
        />
      ))}
    </>
  );
};
